import { db } from 'src/config/firebase';

const getVideo = async (serviceId) => {
  try {
    const snapshot = await db
      .ref('Videos')
      .orderByChild('owner')
      .equalTo(serviceId)
      .once('value');
    const data = await snapshot.val();

    const arr = [];
    for (const val in data) {
      arr.push(data[val]);
    }

    return arr;
  } catch (error) {
    console.warn('Error fetching videos: ', error.message);
  }
};
export default getVideo;
